/**
 * Scrolls smoothly to an element by ID using native scrollIntoView.
 *
 * @param {string} elementId - ID of the element to scroll to (e.g., 'mmd-widget')
 * @returns {boolean} true if element was found and scrolled, false otherwise
 */
export const scrollToElement = (elementId) => {
	if (!elementId) return false;

	const target = document?.getElementById(elementId);
	if (!target) {
		return false;
	}

	try {
		target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		return true;
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('[ws-vehicle-ctas] scrollToElement failed', err);
		return false;
	}
};

export default scrollToElement;
